import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Spinner } from "react-bootstrap";
import { useTranslate } from "../../context/TranslationContext";
import Button from "../button";
import "./style.css";

const SwitchToBothRoleModal = ({
  show,
  close,
  onConfirm,
  isLoading,
  title,
  paragraph1,
  paragraph2,
  roleText,
}) => {
  const { t } = useTranslate("checkout");
  return (
    <Modal show={show} centered onHide={close}>
      <button className="closeButton" onClick={close}>
        <FontAwesomeIcon icon={faTimes} />
      </button>
      <Modal.Body className="text-center">
        <h4 className="modalHeading">{title || t("switchRoleModal.title")}</h4>
        <p className="text-muted">
          {paragraph1 || t("switchRoleModal.paragraph1")}
        </p>
        <p className="text-muted mb-4">
          {paragraph2 || t("switchRoleModal.paragraph2")}{" "}
          <strong>{roleText || t("switchRoleModal.role")}</strong>?
        </p>

        <div className="d-flex justify-content-center gap-3 mt-3">
          <Button
            text={
              isLoading ? (
                <Spinner size="sm" style={{ color: "var(--primaryColor)" }} />
              ) : (
                t("switchRoleModal.yesBtn")
              )
            }
            className="primaryButton"
            onClick={onConfirm}
            disabled={isLoading}
          />
          <Button
            text={t("switchRoleModal.cancelBtn")}
            className="secondaryButton"
            onClick={close}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SwitchToBothRoleModal;
